export default {
  en: {
    newSpecialOffer: 'New Special Offer',
    hotel: 'Hotel',
    cancel: 'Cancel',
    create: 'Create',
    createContractSuccessTitle: 'Success',
    createContractSuccessMessage: 'Create Contract Success.'
  },
  th: {
    newSpecialOffer: 'สร้างข้อเสนอพิเศษ',
    hotel: 'โรงแรม',
    cancel: 'ยกเลิก',
    create: 'สร้าง',
    createContractSuccessTitle: 'สำเร็จ',
    createContractSuccessMessage: 'สร้างข้อเสนอพิเศษใหม่สำเร็จ'
  }
}
